import { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import { CSSProperties } from 'styled-components';

type Props = {
  animation?: Record<string, string | unknown>;
  className?: string;
  style?: CSSProperties;
  loop?: boolean;
  onComplete?: () => void;
  preserveAspectRatio?: string;
  idLottie?: string;
  idTest?: string;
};

export const Lottie = ({
  animation,
  className,
  style,
  loop = true,
  onComplete,
  preserveAspectRatio = 'xMidYMid slice',
  idLottie,
  idTest,
}: Props) => {
  const innerRef = useRef<HTMLDivElement>(null);

  const renderAnimation = () => {
    return lottie.loadAnimation({
      renderer: 'svg',
      loop: loop,
      autoplay: true,
      animationData: animation,
      container: innerRef.current as HTMLDivElement,
      rendererSettings: {
        className: 'animation_selphi_selphiD',
        preserveAspectRatio: preserveAspectRatio,
      },
    });
  };

  useEffect(() => {
    const animation = renderAnimation();
    animation.addEventListener('complete', () => {
      onComplete && onComplete();
    });

    return () => {
      animation.removeEventListener('complete');
      animation.destroy();
    };
  }, [innerRef]);

  return (
    <div
      className={className}
      ref={innerRef}
      style={style}
      id={idLottie}
      test-id={idTest}
    />
  );
};
